import React, { FC, useState, useEffect, memo, useRef } from "../../../lib/teact/teact";
import Button from "../../ui/Button";
import { AdminApi } from "../restapi/adminApi";
type OwnProps = {

}

const ApiCall: FC<OwnProps> = ({ }) => {
    const id = "kqxsResultDiv"
    const ref = useRef<HTMLDivElement>()
    const [state, setState] = useState({
        response: ""
    })
    function GetKQTTDP() {
        AdminApi.GetKQTTDP(null).then(res => {
            setState(prev => ({ ...prev, response: res.data }))
            const obj = document.getElementById(id)
            obj!.innerHTML = JSON.stringify(res.data)
        })
    }
    function GetKQXSHN() {
        AdminApi.GetKQXSHN(null).then(res => {
            setState(prev => ({ ...prev, response: res.data }))
            const obj = document.getElementById(id)
            obj!.innerHTML = JSON.stringify(res.data)
        })
    }
    function GetKQTTXSHN() {
        AdminApi.GetKQTTXSHN(null).then(res => {
            setState(prev => ({ ...prev, response: res.data }))
            const obj = document.getElementById(id)
            obj!.innerHTML = JSON.stringify(res.data)
        })
    }
    function GetKqMinhNgoc() {
        AdminApi.GetKQMinhNgoc(null).then(res => {
            setState(prev => ({ ...prev, response: res.data }))
            const obj = document.getElementById(id)
            obj!.innerHTML = JSON.stringify(res.data)
        })
    }
    function GetKqTtXSKTVN() {
        AdminApi.GetKQTTXSKTVN(null).then(res => {
            setState(prev => ({ ...prev, response: res.data }))
            const obj = document.getElementById(id)
            obj!.innerHTML = JSON.stringify(res.data)
        })
    }
    function GetXsMn_MB() {
        AdminApi.GetXSMN_MB(null).then(res => {
            setState(prev => ({ ...prev, response: res.data }))
            const obj = document.getElementById(id)
            obj!.innerHTML = JSON.stringify(res.data)
        })
    }
    function GetXsMn_MT() {
        AdminApi.GetXSMN_MT(null).then(res => {
            setState(prev => ({ ...prev, response: res.data }))
            const obj = document.getElementById(id)
            obj!.innerHTML = JSON.stringify(res.data)
        })
    }
    function GetXsMn_MN() {
        AdminApi.GetXSMN_MN(null).then(res => {
            setState(prev => ({ ...prev, response: res.data }))
            const obj = document.getElementById(id)
            obj!.innerHTML = JSON.stringify(res.data)
        })
    }
    function RestartAllService() {

    }
    return (
        <div className=" form-content">
            Tải kqxs manual
            {/* <Button onClick={GetKQTTDP}> Tải KQ GetKQTTDP</Button> */}
            <Button onClick={GetKQTTXSHN}>Trực tiếp XSHN 3 miền</Button>
            <Button onClick={GetKQXSHN}> XSHN  3 miền</Button>
            <Button onClick={GetKqMinhNgoc}> MinhNgoc  3 miền</Button>
            <Button onClick={GetKqTtXSKTVN}> KQTT XSKTVN  3 miền</Button>
            <Button onClick={GetXsMn_MB}> xsmn.mobi MB</Button>
            <Button onClick={GetXsMn_MT}> xsmn.mobi MT</Button>
            <Button onClick={GetXsMn_MN}> xsmn.mobi MN</Button>
            {/* <Button onClick={RestartAllService}> Khởi động lại Service</Button> */}
            <div id={id} contentEditable="true" className=" editable-div" ref={ref}>

            </div>
        </div>

    )
}

export default memo(ApiCall);